import {
  Button,
  ControlGroup,
  FormGroup,
  NumericInput,
  type IconName,
  type MaybeElement,
} from "@blueprintjs/core";
import type { CanvasRect } from "./layout-canvas-utils";

export type LayoutCanvasPositionInputsProps = {
  index: number;
  rect: CanvasRect;
  canvasWidth: number;
  canvasHeight: number;
  minTileSize: number;
  disabled?: boolean;
  label?: string;
  onChange: (rect: CanvasRect) => void;
  onDelete: () => void;
  // Override the onDelete control's icon/intent/title — some callers
  // repurpose it for a non-destructive action (e.g. "switch back to Bottom
  // placement") and shouldn't render it as a destructive trash button.
  deleteIcon?: IconName | MaybeElement;
  deleteIntent?: "danger" | "none";
  deleteTitle?: string;
};

export function LayoutCanvasPositionInputs({
  index,
  rect,
  canvasWidth,
  canvasHeight,
  minTileSize,
  disabled,
  label,
  onChange,
  onDelete,
  deleteIcon = "trash",
  deleteIntent = "danger",
  deleteTitle,
}: LayoutCanvasPositionInputsProps) {
  return (
    <FormGroup disabled={disabled} label={label ?? `Position ${index + 1}`}>
      <ControlGroup fill>
        <FormGroup disabled={disabled} label="X">
          <NumericInput
            min={0}
            max={Math.max(0, canvasWidth - rect.width)}
            disabled={disabled}
            allowNumericCharactersOnly
            fill
            value={rect.x}
            onValueChange={(value) => onChange({ ...rect, x: value })}
          />
        </FormGroup>
        <FormGroup disabled={disabled} label="Y">
          <NumericInput
            min={0}
            max={Math.max(0, canvasHeight - rect.height)}
            disabled={disabled}
            allowNumericCharactersOnly
            fill
            value={rect.y}
            onValueChange={(value) => onChange({ ...rect, y: value })}
          />
        </FormGroup>
        <FormGroup disabled={disabled} label="Width">
          <NumericInput
            min={minTileSize}
            disabled={disabled}
            allowNumericCharactersOnly
            fill
            value={rect.width}
            onValueChange={(value) => onChange({ ...rect, width: value })}
          />
        </FormGroup>
        <FormGroup disabled={disabled} label="Height">
          <NumericInput
            min={minTileSize}
            disabled={disabled}
            allowNumericCharactersOnly
            fill
            value={rect.height}
            onValueChange={(value) => onChange({ ...rect, height: value })}
          />
        </FormGroup>
        <FormGroup label={<>{" "}</>}>
          <Button
            disabled={disabled}
            icon={deleteIcon}
            intent={deleteIntent}
            title={deleteTitle}
            minimal
            onClick={onDelete}
          />
        </FormGroup>
      </ControlGroup>
    </FormGroup>
  );
}
